import type { ToolCallLinkEntry } from "@demo/server/api/contracts/toolCall";
import { strings } from "@demo/utils/strings";

import ImageTileStrip from "./ImageTileStrip";
import ToolCallResultsBody, { describeResultCount } from "./ToolCallResultsBody";

export interface TextImageResultsListProps {
  /** The query, shown in full above the results. */
  query?: string;
  results: ToolCallLinkEntry[];
  /** While the search runs the strip shows generic placeholder tiles, not thumbnails. */
  isStreaming: boolean;
}

/**
 * The expanded body of `search.text_image_search` — a text query that returns images (not to be
 * confused with `search.image_search`, the reverse image search). The query, a status line, and
 * the tile strip.
 */
function TextImageResultsList({ query, results, isStreaming }: TextImageResultsListProps) {
  const status = isStreaming ? strings.toolCall.imageResults.searching : describeResultCount(results.length);

  return (
    <ToolCallResultsBody
      isStreaming={isStreaming}
      query={query}
      status={status}
      statusTestId="text-image-results-status"
    >
      <ImageTileStrip isStreaming={isStreaming} results={results} />
    </ToolCallResultsBody>
  );
}

export default TextImageResultsList;
